module.exports = __webpack_public_path__ + "9894be1c277a75625f94a39e7c687e86.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/trailer_preview-320.webp.png
// module id = 556
// module chunks = 0